import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import _ from 'lodash';
import {NgForm} from '@angular/forms';

@AcDialog({
  height: 540,
  width: 950
})
@Component({
  selector: 'web-service-dialog',
  templateUrl: './web-service-dialog.component.html',
  styleUrls: ['./web-service-dialog.component.scss']
})
export class WebServiceDialogComponent implements OnInit, AfterViewInit {

  implementation: any;
  templates;
  numberPortabilityAgentTypes: any;
  isEditMode: boolean;

  @ViewChild('webServiceFrom') webServiceFrom: NgForm;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {

    this.templates = dialogConfig.dialogData.templates;
    this.numberPortabilityAgentTypes = dialogConfig.dialogData.numberPortabilityAgentTypes;
    this.isEditMode = dialogConfig.dialogData.isEditMode;
    this.implementation = dialogConfig.dialogData.data;

    dialogConfig.submitButtonDisabled = true;

    this.dialogConfig.preSubmit = () => {
      dialogConfig.dialogData.data = this.implementation;
      return true;
    };
  }

  ngOnInit(): void {

  }

  agentTypeSelected(selectedAgentType): void {
    this.implementation = _.cloneDeep(this.templates.find((template) => {
      return template.numberPortabilityAgentType === selectedAgentType;
    }));
  }

  displayField(params: any, param): boolean {
    if (!param.templateExist) {
      return false;
    } else if (!param.displayCondition) {
      return true;
    }

    const targetField = params.filter(i => i.name === param.displayCondition.field);
    return _.isEmpty(targetField) || String(targetField[0].value) === param.displayCondition.value;
  }

  ngAfterViewInit(): void {
    this.webServiceFrom.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.webServiceFrom.form.valid;
    });
  }

}
